<template>
  <div id="app">
    <div class="wrapper">
      <Head v-if="routeName !== 'cgspVideo'&&routeName!== 'cgspVideoDetail'&&routeName!== 'registerManual'"></Head>
      <router-view/>
    </div>
    <Footer></Footer>

  </div>
</template>

<script>
  export default {
    name: 'App',
    computed: {
      routeName() {
        return this.$route.name
      }
    }
  }
</script>

<style>
  #app {
    width: 100%;
    height: auto;
  }
  .txtFLASH {
    /*font-size: 20px;*/
    color: red;
    /*margin: 10px;*/
    animation: changeshadow 1s ease-in infinite;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: changeshadow 1s linear infinite;
    -moz-animation: changeshadow 1s linear infinite;
    -ms-animation: changeshadow 1s linear infinite;
    -o-animation: changeshadow 1s linear infinite;
  }

  @keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  /* 添加兼容性前缀 */
  @-webkit-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-moz-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-ms-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-o-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }
</style>

<style  scoped>
  .wrapper {
    min-height: calc(100vh - 110px);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue